import { z } from "zod";
/**
 * Shared query + response contracts for the P20 Reports hub.
 * All amounts are GBP minor-unit integers (`*_minor`). Read-only — no writes.
 */
/** Inclusive ISO `YYYY-MM-DD` UTC-day range. Presets resolve client-side to a concrete range. */
export const ReportRangeQuery = z.object({
    // `z.string().date()` requires zod >= 3.23. If the installed zod is older,
    // replace with: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "must be YYYY-MM-DD").
    from: z.string().date(),
    to: z.string().date(),
});
